import { Divider, Box, Text } from '@cad-arc';
import { AttributeOption, CallForServiceOption } from '@mark43/cad-api';
import { SectionTitle } from '../../fr-event-common-components/section-title';
import { ASSIGNMENT_MODAL_COMMON_SIZE, ASSIGNMENT_MODAL_PADDING_TOP } from '../constants';
import { LocationRiskPriority } from '../../common/components/location-risk-priority';

export function AssignmentModalDetailsCfs({
    callForService,
    additionalCallForServices,
    riskLevel,
    eventPriority,
}: {
    eventPriority?: AttributeOption;
    riskLevel?: AttributeOption;
    callForService?: CallForServiceOption;
    additionalCallForServices?: CallForServiceOption[];
}) {
    const additionalCallForServicesGrouped =
        additionalCallForServices?.length == 1
            ? additionalCallForServices[0].label
            : additionalCallForServices?.map((e) => e.label).join(', ') ?? '';

    if (!callForService) {
        return null;
    }

    return (
        <Box>
            <SectionTitle title="CFS" />
            <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE}>{callForService.label}</Text>
            {!!additionalCallForServices?.length && (
                <Text fontSize={ASSIGNMENT_MODAL_COMMON_SIZE} style={{ whiteSpace: 'pre-wrap' }}>
                    Additional: {additionalCallForServicesGrouped}
                </Text>
            )}
            <LocationRiskPriority
                eventPriority={eventPriority}
                riskLevel={riskLevel}
                size={ASSIGNMENT_MODAL_COMMON_SIZE}
            />
            <Divider style={ASSIGNMENT_MODAL_PADDING_TOP} />
        </Box>
    );
}
